import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Dropdown } from 'primeng/dropdown';
import { InputSwitch } from 'primeng/inputswitch';
import { ConfirmationService, MessageService } from "primeng/api";
import { BreadcrumbService } from 'app/breadcrumb.service';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { IUser } from 'app/shared/Domains/IUser';
import { Router } from '@angular/router';
import { Employee } from 'app/Employees/domain/employee';
import { ICompany } from 'app/shared/Domains/company';
import { Configuration } from 'config/config';
import { IBranch } from 'app/shared/Domains/branch';
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
  selector: 'app-pay-salary-to-employees',
  templateUrl: './pay-salary-to-employees.component.html',
  styleUrls: ['./pay-salary-to-employees.component.css']
})
export class PaySalaryToEmployeesComponent implements OnInit {
  @ViewChild("searchEmployee", { static: false }) searchEmployeeInput: ElementRef;
  allDesignationDd: any[];
  allDesignation: any[];
  mode: string = 'add';
  enterSteps: any[];
  isConfirmationBox: boolean;
  showIssuesEmployeeSalary: boolean;
  currentStep: any;
  currencyDropDown: any[] = [];
  user: any;
  role: any;
  Trainers: any[];
  users: any[];
  employeeFromApi: any[];
  loading: boolean = false;
  loadingSummary: boolean = false;
  imgPreview: boolean = false;
  imgPreviewImg: any;
  userObj: IUser;
  TrainersFee: any[];
  Years: any[];
  Month: any[];
  selectedYears: number;
  selectedMonth: string;
  allPreviousSalaryOfEmployee: any;
  isThisMonthPaid: boolean;
  first: number = 0;
  isHeaderCheckBox: boolean = false;
  employee: Employee;
  sourceUsers: any[];
  isIssueEmployeeSalaryButton: boolean = false;
  currentMonth: number;
  currentYear: number;
  date: Date;
  months: { label: string; value: number }[];
  years: { label: string; value: number }[];
  company: ICompany;
  payInvoiceCurrentTime: Date;
  allEmployeeArray: any[];
  branch: IBranch;

  constructor(
    private LanguageService: LanguageService,
    private confirmationService: ConfirmationService,
    private breadcrumbService: BreadcrumbService,
    private appServiceManager: AppServiceManager,
    private messageService: MessageService,
    public config: Configuration,
    private route: Router
  ) {
    this.breadcrumbService.setItems([
      { label: "Issue Salary" },
    ]);
  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("PaySalaryToEmployeesComponent", label);
  }
  ngOnInit(): void {
    this.role = AuthService.getLoggedInRole();
    this.user = AuthService.getLoggedInUser();
    this.getCompany();
    this.getBranch();
    this.date = new Date();
    this.payInvoiceCurrentTime = new Date();
    this.userObj = new IUser();
    this.isConfirmationBox = false;
    this.showIssuesEmployeeSalary = false;
    this.isThisMonthPaid = false;
    this.employee = new Employee();
    this.users = [];
    this.sourceUsers = [];
    this.allEmployeeArray = [];
    this.currentMonth = (this.date.getMonth() + 1);
    this.currentYear = this.date.getUTCFullYear();
    this.company = new ICompany();

    this.Years = [
      { label: "2010", value: 2010 },
      { label: "2011", value: 2011 },
      { label: "2012", value: 2012 },
      { label: "2013", value: 2013 },
      { label: "2014", value: 2014 },
      { label: "2015", value: 2015 },
      { label: "2016", value: 2016 },
      { label: "2017", value: 2017 },
      { label: "2018", value: 2018 },
      { label: "2019", value: 2019 },
      { label: "2020", value: 2020 },
      { label: "2021", value: 2021 },
      { label: "2022", value: 2022 },
      { label: "2023", value: 2023 },
      { label: "2024", value: 2024 },
      { label: "2025", value: 2025 },
      { label: "2026", value: 2026 },
      { label: "2027", value: 2027 },
      { label: "2028", value: 2028 },
      { label: "2029", value: 2029 },
      { label: "2030", value: 2030 }
    ];

    this.selectedYears = new Date().getUTCFullYear();

    this.Month = [
      { label: "January", value: "January" },
      { label: "February", value: "February" },
      { label: "March", value: "March" },
      { label: "April", value: "April" },
      { label: "May", value: "May" },
      { label: "June", value: "June" },
      { label: "July", value: "July" },
      { label: "August", value: "August" },
      { label: "September", value: "September" },
      { label: "October", value: "October" },
      { label: "November", value: "November" },
      { label: "December", value: "December" },
    ];

    this.months = [
      { label: "Select Month", value: null },
      { label: "January", value: 1 },
      { label: "Febuary", value: 2 },
      { label: "March", value: 3 },
      { label: "April", value: 4 },
      { label: "May", value: 5 },
      { label: "June", value: 6 },
      { label: "July", value: 7 },
      { label: "August", value: 8 },
      { label: "September", value: 9 },
      { label: "October", value: 10 },
      { label: "November", value: 11 },
      { label: "December", value: 12 },
    ];

    this.years = [
      { label: "Select Year", value: null },
      { label: "2015", value: 2015 },
      { label: "2016", value: 2016 },
      { label: "2017", value: 2017 },
      { label: "2018", value: 2018 },
      { label: "2019", value: 2019 },
      { label: "2020", value: 2020 },
      { label: "2021", value: 2021 },
      { label: "2022", value: 2022 },
      { label: "2023", value: 2023 },
      { label: "2024", value: 2024 },
      { label: "2025", value: 2025 },
      { label: "2026", value: 2026 },
      { label: "2027", value: 2027 },
      { label: "2028", value: 2028 },
      { label: "2029", value: 2029 },
      { label: "2030", value: 2030 },
      { label: "2031", value: 2031 },
      { label: "2032", value: 2032 },
      { label: "2033", value: 2033 },
      { label: "2034", value: 2034 },
      { label: "2035", value: 2035 },
      { label: "2036", value: 2036 },
      { label: "2037", value: 2037 },
      { label: "2038", value: 2038 },
      { label: "2039", value: 2039 },
      { label: "2040", value: 2040 },
    ];

    const month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    this.selectedMonth = month[new Date().getUTCMonth()];
    this.userObj.company = AuthService.getLoggedInCompany();
    this.userObj.branch = AuthService.getLoggedInBranch();
    this.getTrainers();

  }

  ngAfterViewInit() {
    this.searchEmployeeInput.nativeElement.focus();
  }

  getCompany() {
    this.appServiceManager.get("companies/current").subscribe(
      (res) => {
        if (res) {
          this.company = res;
        } else {
          this.company = new ICompany();
          this.messageService.clear();
          this.messageService.add({
            severity: "info",
            summary: "Info Message",
            detail: "Something Went Wrong",
          });
        }
      },
      (error) => {
        this.company = new ICompany();
        this.messageService.clear();
        this.messageService.add({
          severity: "error",
          summary: "Error Message",
          detail: error,
        });
      }
    );
  }
  getBranch() {
    this.appServiceManager.get('branches/' + this.user.branch).subscribe((res) => {
      if (res) {
        this.branch = res;
      } else {
        this.branch = new IBranch();
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }
    },
      (error) => {
        this.branch = new IBranch();
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }
  getEmployees() {
    this.loading = true;
    let data = { date: this.date }
    this.appServiceManager.put(`employees/company/${this.user.company}/branch/${this.user.branch}/getUnpaidEmployees`, data).subscribe((res: any) => {
      if (res.length > 0) {
        this.employeeFromApi = res;
        this.setEmployeeObj(res);
      } else {
        this.employeeFromApi = [];
        this.setEmployeeObj([]);
      }
      this.loading = false;
    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  setEmployeeObj(employeeFromApi) {
    let employeeDataToDisplay = [];
    employeeFromApi.map(async r => {
      let userDataReady = r;
      userDataReady["salary"] = await this.getUserSalary(r.designation);
      userDataReady["trainerShare"] = await this.getTrainerShare(r.trainerId);
      userDataReady["totalSalary"] = userDataReady["trainerShare"] + userDataReady["salary"];
      userDataReady["isSelectedForPay"] = false;
      employeeDataToDisplay.push(userDataReady);
    })
    this.users = employeeDataToDisplay;
    this.sourceUsers = employeeDataToDisplay;
  }

  searchLocal(value, type) {
    this.isHeaderCheckBox = false;
    this.setAllCheckBoxes();
    let matchedName = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "") {
        this.users = Object.assign([], this.sourceUsers);
      }
      if (!value) {
        this.users = Object.assign([], this.sourceUsers);
      }
      if (value != "") {
        if (type === "name") {
          matchedName = Object.assign([], this.sourceUsers).filter(
            cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
        }

        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        const source = matchedName;
        this.users = source.filter(distinct);

        if (this.users.length === 0) {
          this.users = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.first = 0;
          if (this.users.length === 1) {
            this.first = 0;
          }
          this.users = [...this.users];
        }
      }
    } else {
      this.users = Object.assign([], this.sourceUsers);
      this.users = [...this.users];
    }
  }


  onPageChange(event) {
    this.first = event.first;
  }

  clear() {
    this.employee = new Employee();
    this.searchLocal("", "");
    this.first = 0;
  }

  setAllCheckBoxes() {
    if (this.isHeaderCheckBox) {
      this.users.filter(x => {
        x.isSelectedForPay = true;
      });
      this.isIssueEmployeeSalaryButton = true;
    } else if (!this.isHeaderCheckBox) {
      this.users.filter(x => {
        x.isSelectedForPay = false;
      });
      this.isIssueEmployeeSalaryButton = false;

    }
  }

  getTrainers() {
    this.loading = true;
    this.appServiceManager.get('Trainers/company/' + this.user.company + '/branch/' + this.user.branch).subscribe((res) => {
      if (res.length > 0) {
        this.Trainers = res;
      } else {
        this.Trainers = [];
      }
      this.getAllTrainersFee();

    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  getAllDesignation() {
    this.appServiceManager.get(`hr/getAllDesignation/company/${this.user.company}/branch/${this.user.branch}`).subscribe((res: any) => {
      if (res.length > 0) {
        this.allDesignation = res;
        this.allDesignationDd = this.createDdOptions(res, 'Select designation');

      } else {
        this.allDesignation = [];
      }
      this.getEmployees();
    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  getAllTrainersFee() {
    let body = {
      date: new Date(this.date)
    }
    this.appServiceManager.put(`hr/getAllTrainersFee/company/${this.user.company}/branch/${this.user.branch}`, body).subscribe((res: any) => {
      if (res.length > 0) {
        this.TrainersFee = res;

      } else {
        this.TrainersFee = [];
      }
      this.getAllDesignation();
      this.setEmployeeObj(this.employeeFromApi);

    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  showIssuesEmployeeSalaryDetails() {
    this.showIssuesEmployeeSalary = true;

  }

  createDdOptions(ValueDetails: any[], name: string) {
    var itemsDd = [];
    var FirstOption = { label: name, value: 0 };
    itemsDd.push(FirstOption);
    ValueDetails.forEach(element => {
      var item = { label: element.name, value: element._id };
      itemsDd.push(item);
    });
    return itemsDd;
  }

  openPhoto(imgUri) {
    this.imgPreview = true;
    this.imgPreviewImg = imgUri;
  }

  closePhotoPreview() {
    this.imgPreview = false;
    this.imgPreviewImg = "";
  }

  getUserSalary(id) {
    if (id == 0 || id == undefined || id == "" || id == null || !this.allDesignation) {
      return 0;
    }
    let userDesignation = this.allDesignation.filter(d => d._id == id)[0];
    return userDesignation.salary;
  }

  getTrainerShare(trainerId) {
    if (!this.Trainers || !this.TrainersFee) return 0;
    let trainer = this.Trainers.filter(t => t._id == trainerId);
    if (trainer.length > 0) {
      let curentTrainerFees = this.TrainersFee.filter(tf => tf.id == trainer[0]._id);
      if (curentTrainerFees.length > 0) {
        // let feeLength = curentTrainerFees[0].feeDetails.length;
        let totalTrainerShare = 0;
        curentTrainerFees[0].feeDetails.map(ctf => {
          totalTrainerShare += parseInt(trainer[0].trainerShare);
        })
        return totalTrainerShare;
      }
      return 0;

    } else {
      return 0;

    }
  }

  issuesEmployeeSalary() {
    this.isConfirmationBox = true;
    this.confirmationService.confirm({
      message: "Are you sure you want to issue Employees Salary?",
      accept: () => {
        let employeesSalaries = [];
        this.users.filter(x => x.isSelectedForPay).map((employee) => {
          let data = {
            id: employee._id,
            name: employee.name,
          };
          data["salary"] = {
            invoice: Math.round(Math.random() * 1000).toString(),
            salary: employee.salary,
            trainerShare: employee.trainerShare,
            totalPaid: employee.totalSalary,
            date: this.date
          };
          Object.keys(data).forEach(key => data[key] === undefined && delete data[key]);
          employeesSalaries.push(data);
        });
        this.appServiceManager.put('employees/updateEmployeeSalaryInBulk', { employeesSalaries }).subscribe((res: any) => {
          if (res.status) {
            this.allEmployeeArray = employeesSalaries;
            setTimeout(() => {
              this.printSalariesInvoice();
            }, 1000);
            this.messageService.clear();
            this.messageService.add({
              severity: "success",
              summary: "Success Message",
              detail: "Employees Salary Successfully Issued",
            });
            this.getTrainers();
            this.showIssuesEmployeeSalary = false;
            this.isHeaderCheckBox = false;
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Something went wrong' });
          }
        },
          (error) => {
            this.loading = false;
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      },
      reject: () => { }
    });
  }

  setIssueSalaryButtonVisibility() {
    let checkedEmployee = this.users.filter(x => x.isSelectedForPay);
    if (checkedEmployee.length > 0) {
      this.isIssueEmployeeSalaryButton = true;
    } else {
      this.isIssueEmployeeSalaryButton = false;
      this.isHeaderCheckBox = false;

    }
  }

  onChangeMonthDropDown() {
    this.date.setMonth(this.currentMonth - 1);
    this.isHeaderCheckBox = false;
    this.isIssueEmployeeSalaryButton = false;
    this.getTrainers();

  }

  onChangeYearDropDown() {
    this.date.setFullYear(this.currentYear);
    this.isHeaderCheckBox = false;
    this.isIssueEmployeeSalaryButton = false;
    this.getTrainers();

  }

  getDesignationTitle(designationId) {
    let designationObject = this.allDesignation.find(x => x._id == designationId);
    return designationObject.name;

  }

  printSalariesInvoice(): void {
    let printContents, popupWin;
    printContents = document.getElementById("salariesInvoice").innerHTML;
    popupWin = window.open(
      "",
      "_blank",
      "top=0,left=0,height=100%,width=auto"
    );
    popupWin.document.open();
    popupWin.document.write(`
      <html>
      <head>
        <title>Gym Employee Salary Invoice</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }

            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }

            .invoice-box table td {
                padding: 5px;
                vertical-align: top;
            }

            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }

            .invoice-box table tr.top table td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.top table td.title {
                font-size: 45px;
                line-height: 45px;
                color: #333;
            }

            .invoice-box table tr.information table td {
                padding-bottom: 40px;
            }

            .invoice-box table tr.heading td {
                background: #eee;
                border-bottom: 1px solid #ddd;
                font-weight: bold;
            }

            .invoice-box table tr.details td {
                padding-bottom: 20px;
            }

            .invoice-box table tr.item td {
                border-bottom: 1px solid #eee;
            }
            .invoice-box table tr.item.last td {
                border-bottom: none;
            }
            .invoice-box table tr.item input {
                padding-left: 5px;
            }
            .invoice-box table tr.item td:first-child input {
                margin-left: -5px;
                width: 100%;
            }
            .invoice-box table tr.total td:nth-child(2) {
                border-top: 2px solid #eee;
                font-weight: bold;
            }
            .invoice-box input[type="number"] {
                width: 60px;
            }
            @media print {
              .invoiceBreakPage {page-break-before: always;}
            }

            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }

                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
            .rtl {
                direction: rtl;
                font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial,
                    sans-serif;
            }
            .rtl table {
                text-align: right;
            }
            .rtl table tr td:nth-child(2) {
                text-align: left;
            }
        </style>
      </head>
      <body>${printContents}</body>
      </html>
    `);
  }

  getMonthName(monthNumber) {
    const month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    let name = month[monthNumber - 1];
    return name;
  }
}
